export enum SupportEmailRequestStatus {
    New = 0,
    Ongoing = 1,
    Done = 2,
    Cancelled = 3,
    NotRelevant = 4,
}

export enum SupportEmailRequestCategory {
    Support = 0,
    Privacy = 1,
    General = 2,
    Unknown = 3,
}

export enum SupportEmailAiAnalysisStatus {
    Pending = 0,
    Completed = 1,
    Failed = 2,
    Skipped = 3,
}

export type SupportEmailRequestListItemDto = {
    id: string;
    receivedAt: string;
    category: SupportEmailRequestCategory;
    status: SupportEmailRequestStatus;
    sender: string;
    recipient: string;
    subject?: string | null;
    attachmentCount: number;
    isSuspicious: boolean;
    aiAnalysisStatus: SupportEmailAiAnalysisStatus;
};

export type SupportEmailRequestAttachmentDto = {
    id: string;
    fileName: string;
    contentType: string;
    fileKey: string;
    sizeBytes: number;
};

export type SupportEmailRequestDetailDto = {
    id: string;
    receivedAt: string;
    category: SupportEmailRequestCategory;
    status: SupportEmailRequestStatus;
    sender: string;
    recipient: string;
    fromHeader?: string | null;
    subject?: string | null;
    bodyPlain?: string | null;
    bodyHtml?: string | null;
    messageHeadersJson?: string | null;
    messageId?: string | null;
    internalNotes?: string | null;
    statusUpdatedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    isSuspicious: boolean;
    suspiciousReason?: string | null;
    aiSummary?: string | null;
    proposedAnswer?: string | null;
    aiAnalysisStatus: SupportEmailAiAnalysisStatus;
    aiAnalysisError?: string | null;
    aiAnalyzedAt?: string | null;
    attachments: SupportEmailRequestAttachmentDto[];
};

export type CreateSupportEmailRequestDto = {
    category: SupportEmailRequestCategory;
    sender: string;
    recipient: string;
    fromHeader?: string | null;
    subject?: string | null;
    bodyPlain?: string | null;
    bodyHtml?: string | null;
    internalNotes?: string | null;
};

export type UpdateSupportEmailRequestDto = {
    status: SupportEmailRequestStatus;
    category: SupportEmailRequestCategory;
    internalNotes?: string | null;
    subject?: string | null;
    bodyPlain?: string | null;
    isSuspicious?: boolean | null;
    suspiciousReason?: string | null;
    proposedAnswer?: string | null;
};

export type SupportEmailRequestListFilters = {
    status?: SupportEmailRequestStatus | null;
    category?: SupportEmailRequestCategory | null;
    isSuspicious?: boolean | null;
    from?: string | null;
    to?: string | null;
};
